<template>
  <p class="text-20 text-grey-light">
    <slot />
  </p>
</template>
